
(function () {
  'use strict';

  if (window.__wcScrollRestore) return;
  window.__wcScrollRestore = true;

  var KEY = 'wc-scroll:' + location.pathname + location.search;
  var RETRY_DELAYS = [0, 80, 180, 320, 600, 1000, 1800, 2800];

  function readSaved() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return 0;
      var y = parseInt(raw, 10);
      return (!isNaN(y) && y > 0) ? y : 0;
    } catch (e) { return 0; }
  }

  function restoreTo(y) {
    if (!y) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    

    
    var aborted = false;
    var timers = [];
    var fire = function () { if (!aborted) window.scrollTo(0, y); };

    function cleanup() {
      window.removeEventListener('wheel', abort);
      window.removeEventListener('touchmove', abort);
      window.removeEventListener('keydown', onKey);
    }
    function abort() {
      if (aborted) return;
      aborted = true;
      timers.forEach(clearTimeout);
      cleanup();
    }
    function onKey(e) {
      var k = e.key;
      if (k === 'ArrowUp' || k === 'ArrowDown' || k === 'PageUp' ||
          k === 'PageDown' || k === ' ' || k === 'End' || k === 'Home') {
        abort();
      }
    }
    window.addEventListener('wheel',     abort, { passive: true });
    window.addEventListener('touchmove', abort, { passive: true });
    window.addEventListener('keydown',   onKey);

    fire();
    RETRY_DELAYS.forEach(function (d) {
      if (d === 0) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { fire(); });
        });
      } else {
        timers.push(setTimeout(fire, d));
      }
    });

    
    setTimeout(function () {
      if (!aborted) { aborted = true; cleanup(); }
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    }, RETRY_DELAYS[RETRY_DELAYS.length - 1] + 200);
  }

  function save() {
    try {
      var sy = window.scrollY || window.pageYOffset || 0;
      if (sy > 0) sessionStorage.setItem(KEY, String(sy));
    } catch (e) {}
  }

  restoreTo(readSaved());

  

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var y = readSaved();
      if (y) restoreTo(y);
    }
  });

  
  
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });
})();
